<div>
  <button (click)="clear()">Clear</button>
  <button (click)="undo()">Undo</button>
  <button (click)="redo()">Redo</button>
  <button (click)="toggleEdit()">
    {{ active ? "save" : "edit" }}
  </button>
  <button (click)="toggleUseEraser()">
    {{ useEraser ? "use pencil" : "use eraser" }}
  </button>
  <input type="color" [(ngModel)]="color" />
  <input type="range" [(ngModel)]="thickness" min="{1}" max="{30}" step="{1}" />

  <paintable
    #paintable
    [width]="1024"
    [height]="768"
    [active]="active"
    [useEraser]="useEraser"
    [thickness]="thickness"
    [color]="color"
    [image]="image"
    (onSave)="onSave($event)"
    (onLongPress)="onLongPress()"
  >
    <div class="canvas-inner">test</div>
  </paintable>
</div>
